__webpack_require__.p = "https://auth.dev-bloque.app/";